import { ADMIN_BASE_URL, BASE_URL, MOBILE_BASE_URL,FILE_UPLOAD_BASE_URL } from "../api_const"

export const UPLOAD_OA_BANKING_REPORT = FILE_UPLOAD_BASE_URL+"/meter-report/upload/oa-banking";
export const UPLOAD_TS_CONSUMPTION_REPORT = FILE_UPLOAD_BASE_URL+"/meter-report/upload/tsc-consumption";

export const TS_CONSUMPTION_REPORT_LIST=FILE_UPLOAD_BASE_URL+"/meter-report/tsc-consumption/list";
export const OA_BANKING_REPORT_LIST=FILE_UPLOAD_BASE_URL+"/meter-report/oa-banking/list";

export const OA_BANKING_REPORT_DATA=FILE_UPLOAD_BASE_URL+"/meter-report/oa-banking"; 
export const TS_CONSUMPTION_REPORT_DATA=FILE_UPLOAD_BASE_URL+"/meter-report/tsc-consumption";